import { useState } from 'preact/hooks';
import useTable from '../context/TableContext';
import useAnimals from '../context/AppContext';
import { useToaster } from '../context/ToasterContext';
import SubmitButton from '../components/ui/SubmitButton';
import Form from '../components/ui/Form';
import Input from '../components/ui/Input';
import TextArea from '../components/ui/TextArea';
import { addLocation, findLocations, updateLocation } from '../api/api';

export default function FormLocation(route) {
    let [name, owner, notes, city, address, contact, nextInterventionDate, surface] = [];
    const { tableData, setTableData } = useTable();
    const { locations, setLocations } = useAnimals();
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const addToast = useToaster();

    if (typeof locations == 'undefined' || locations === null) {
        return <div className="text-center pt-5">Loading locations ...</div>;
    }
    if (route.id && locations) {
        const location = locations.find(location => parseInt(location.id) === parseInt(route.id));
        if (location) {
            city = location.city
            name = location.name;
            owner = location.owner;
            address = location.address;
            contact = location.contact;
            nextInterventionDate = location.nextInterventionDateApi;
            surface = location.surface
            notes = location.notes;
        }
    }

    function refreshLocations() {
        const tableDataCopy = JSON.parse(JSON.stringify(tableData));
        findLocations().then((locations) => {
            setLocations(locations);
            tableDataCopy["locations"] = locations;
            setTableData(tableDataCopy)
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        const formLocation = {
            name: fields.name.value,
            owner: fields.owner.value,
            notes: fields.notes.value,
            city: fields.city.value,
            address: fields.address.value,
            contact: fields.contact.value,
            nextInterventionDate: fields.nextInterventionDate.value == '' ? null : fields.nextInterventionDate.value,
            surface: parseInt(fields.surface.value)
        }
        setSubmitButtonDisabled(true);
        if (route && route.id) {
            updateLocation(formLocation, route.id).then(() => {
                addToast('success', 'Terrain mis à jour');
                setSubmitButtonDisabled(false);
                refreshLocations();
                history.go(-1);
            }).catch(() => {
                setSubmitButtonDisabled(false);
                addToast('danger', 'Erreur lors de la mise à jour du terrain');
            });
        } else {
            addLocation(formLocation).then(() => {
                addToast('success', 'Terrain ajouté');
                setSubmitButtonDisabled(false);
                refreshLocations();
                history.go(-1);
            }).catch(() => {
                setSubmitButtonDisabled(false);
                addToast('danger', 'Erreur lors de la création du terrain');
            });
        }
    }

    return (
        <div class="container-md mt-2">
            <h1 class="text-center">Fiche terrain (édition)</h1>
            <Form onSubmit={(handleSubmit)}>
                <Input id="city" label="Commune" type="text" value={city} />
                <Input id="name" label="Nom" type="text" value={name} />
                <Input id="owner" label="Propriétaire" type="text" value={owner} />
                <TextArea id="contact" label="Contact" value={contact} />
                <TextArea id="address" label="Adresse" value={address} />
                <Input id="surface" label="Surface" type="number" value={surface} />
                <TextArea id="notes" label="Notes" value={notes} />
                <div class="form-floating  mb-3">
                    <input class="form-control" id="next_intervention_date" type="date" name="nextInterventionDate" value={nextInterventionDate} />
                    <label class="form-label" for="date">Date de la prochaine intervention</label>
                </div>
                <SubmitButton disabled={submitButtonDisabled} />
            </Form>
        </div>
    );
}